module.exports = __webpack_public_path__ + "media/images/pic/testimonials/awatar-07-a886e1593bad2e10ab32cdcb5cc201b6.svg";